module.exports = __webpack_public_path__ + "static/CHAS-white-0b59207ac3e7ba5159aa4b1167eb5fbd.png";